import dynamic from 'next/dynamic'
import { DemographicsIcon } from 'src/components/insights/icons/demographics'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/population-by-industry.png'

const DemographicsPopulationByIndustry = dynamic(
  () => import('src/components/insights/demographics/cards/population-industry'),
  {
    ssr: false,
  }
)

export const DemographicsPopulationByIndustryWidget: InsightBuilderWidget = {
  id: 'population-by-industry',
  name: 'Population by Industry',
  type: 'Demographics',
  icon: DemographicsIcon,
  component: DemographicsPopulationByIndustry,
  supportedResultTypes: ['alphamap-location'],
  preview,
}
